import React, { useContext } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { AuthContext } from '../contexts/AuthContext';
import { useHistory} from "react-router-dom";
import './Sidebar.scss';

const Sidebar = () => {
  const { logout } = useContext(AuthContext);
  const {push} = useHistory()

  const logoutClicked = () => {
    logout()
    push('/login')
  }
  return (
    <Menu disableAutoFocus right noOverlay>
      <span className="bm-logout-wrap">
        <button onClick={logoutClicked} className="bm-logout">
          Log out
        </button>
      </span>
    </Menu>
  );
};
export default Sidebar;
